/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import MoserObjectUtils from './MoserObjectUtils';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getLongIdentifier

/**
 * @author  Zhuoheng Huang
 */
export default class InsertRecord extends BaseMoserObject{

	obj = null;

	objClone = null;

	parentObj = null;

	srcObjForUpdate = null;

	index = null;

	insertStatus = null;

	propertiesUpdate = null;



	constructor(obj, objClone, parentObj, insertStatus, index) {
		super();
		this.obj = obj;
		this.objClone = objClone;
		this.parentObj = parentObj;
		this.insertStatus = insertStatus;
		this.index = index;
	}

	getObj() {
		return this.obj;
	}

	setObj(obj) {
		this.obj = obj;
	}

	getObjClone() {
		return this.objClone;
	}

	setObjClone(objClone) {
		this.objClone = objClone;
	}

	getInsertStatus() {
		return this.insertStatus;
	}

	setInsertStatus(insertStatus) {
		this.insertStatus = insertStatus;
	}

	getParentObj() {
		return this.parentObj;
	}

	setParentObj(parentObj) {
		this.parentObj = parentObj;
	}

	getSrcObjForUpdate() {
		return this.srcObjForUpdate;
	}

	setSrcObjForUpdate(obj) {
		this.srcObjForUpdate = obj;
	}

	getIndex() {
		return this.index;
	}

	setIndex(index) {
		this.index = index;
	}

	getPropertiesUpdate() {
		if (!this.propertiesUpdate) {
			this.propertiesUpdate = [];
		}
		return this.propertiesUpdate;
	}

	addPropertiesUpdate(properties) {
		if (!this.propertiesUpdate) {
			this.propertiesUpdate = [];
		}
		this.propertiesUpdate.push(properties);
	}

	isDuplicate(other) {
		if (this.getObj() != other.getObj()) {
			return false;
		}
		if (this.getInsertStatus() != other.getInsertStatus()) {
			return false;
		}
		if (this.getParentObj() && other.getParentObj() && "FolderType" == this.getParentObj().getObjectType() && "FolderType" == other.getParentObj().getObjectType()) {
			var thisFolder = this.getParentObj();
			var otherFolder = other.getParentObj();
			return thisFolder.getIdentifier() == otherFolder.getIdentifier();
		}
		return this.getParentObj() == other.getParentObj();
	}

	/**
	 * Convert <code>InsertRecord</code> to <code>JSONObject</code>.
	 * @return {Object} <code>JSONObject</code> for <code>InsertRecord</code> object.
	 */
	toJSON() {
		var result = {};
		result["obj"] = MoserObjectUtils.getLongIdentifier(this.obj);
		if (this.objClone) {
			result["objClone"] = MoserObjectUtils.getLongIdentifier(this.objClone);
		}
		if (this.parentObj) {
			if ("Module" == this.parentObj.getObjectType()) {
				result["parentObj"] = (this.parentObj).getIdentifier();
			} else {
				result["parentObj"] = MoserObjectUtils.getLongIdentifier(this.parentObj);
			}
		}
		if (this.srcObjForUpdate) {
			result["srcObjForUpdate"] = MoserObjectUtils.getLongIdentifier(this.srcObjForUpdate);
		}
		if (this.index != null) {
			result["index"] = this.index;
		}
		result["insertStatus"] = this.insertStatus.value();
		if (!this.propertiesUpdate) {
			return result;
		}
		var ppd = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = this.propertiesUpdate, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var feature = __exp_enFor0[__i_enFor0];
			ppd.push(feature);
		}
		result["propertiesUpdate"] = ppd;
		return result;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/InsertRecord.js